import React, { useEffect, useState } from "react";
import { PageHeader, Modal, Toast, PasswordInput } from "@/components/Layout";
import api, { errorText } from "@/lib/api";

// Parametrii > Securitate: verificarea în doi pași (cod pe e-mail) pornită sau oprită pentru toată instalarea. Doar Admin.
export default function SecuritySettings() {
  const [st, setSt] = useState(null);
  const [ask, setAsk] = useState(null);
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const load = () => api.get("/security/mfa").then(r => setSt(r.data)).catch(e => setMsg({ text: errorText(e, "Eroare"), type: "error" }));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      await api.put("/security/mfa", { enabled: ask, actor_password: pw });
      setAsk(null); setPw(""); load();
      setMsg({ text: ask ? "Verificarea în doi pași a fost pornită." : "Verificarea în doi pași a fost oprită.", type: "success" });
    } catch (e) { setMsg({ text: errorText(e, "Eroare"), type: "error" }); }
  };
  if (!st) return <><PageHeader title="Securitate" /><Toast msg={msg.text} type={msg.type} /></>;
  return (
    <>
      <PageHeader title="Securitate" subtitle="Verificarea în doi pași, cu cod trimis pe e-mail" />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{ padding: 20, maxWidth: 760 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <div>
            <div style={{ fontWeight: 700 }} data-testid="sec-state">{st.enabled ? "Pornită pentru toată instalarea" : "Oprită pentru toată instalarea"}</div>
            <div style={{ fontSize: 13, color: "#64748B", marginTop: 4 }}>Obligatorie pentru rolurile: {st.required_roles.join(", ")}. Opțională pentru ceilalți (din Contul meu).</div>
          </div>
          {st.enabled
            ? <button className="btn btn-danger" onClick={() => setAsk(false)} data-testid="sec-off">Oprește</button>
            : <button className="btn btn-primary" onClick={() => setAsk(true)} data-testid="sec-on">Pornește</button>}
        </div>
        {!st.email_ready && <div style={{ marginTop: 14, background: "#FEF3C7", color: "#78350F", padding: "10px 12px", borderRadius: 6, fontSize: 13 }} data-testid="sec-no-smtp">
          E-mailul platformei nu este configurat (Parametrii, Email SMTP): codurile nu pot fi trimise.</div>}
        {!st.enabled && <div style={{ marginTop: 14, background: "#FEE2E2", color: "#7F1D1D", padding: "10px 12px", borderRadius: 6, fontSize: 13 }} data-testid="sec-warning">{st.warning}</div>}
      </div>
      {ask !== null && (
        <Modal title={ask ? "Pornește verificarea în doi pași" : "Oprește verificarea în doi pași"} onClose={() => { setAsk(null); setPw(""); }} width={520}>
          {!ask && <div style={{ background: "#FEE2E2", color: "#7F1D1D", padding: "10px 12px", borderRadius: 6, fontSize: 13, marginBottom: 12 }}>{st.warning}</div>}
          <label className="label label-req">Parola dumneavoastră</label>
          <PasswordInput value={pw} onChange={e => setPw(e.target.value)} testId="sec-pw" autoComplete="current-password" />
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
            <button className="btn btn-secondary" onClick={() => { setAsk(null); setPw(""); }}>Anulează</button>
            <button className={ask ? "btn btn-primary" : "btn btn-danger"} onClick={save} data-testid="sec-confirm">{ask ? "Pornește" : "Oprește"}</button>
          </div>
        </Modal>
      )}
    </>
  );
}
